import { useQueryClient } from '@tanstack/react-query'
import { usePermission } from '@shared/hooks/permissions'

import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import RefreshIcon from '@mui/icons-material/Refresh'

export default function RefreshButton() {
    const { hasPermission } = usePermission()
    const queryClient = useQueryClient()

    return (
        <Tooltip
            title='تحديث'
            placement='right'
        >
            <IconButton
                sx={{
                    position: 'fixed',
                    bottom: hasPermission('add_estimation') ? 75 : 15,
                    insetInlineEnd: 15
                }}
                onClick={() => queryClient.invalidateQueries({ queryKey: ['estimations'] })}
            >
                <RefreshIcon />
            </IconButton>
        </Tooltip>
    )
}